import { MetricFinderState } from '@core/store/states/metric-finder.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  purgeMetricFinderMetrics,
  setMetricFinderHolder,
  setMetricFinderLoader,
  setMetricFinderMetrics
} from '@core/store/actions/metric-finder.actions'

export const initialState: MetricFinderState = {
  metrics: undefined,
  metricHolder: undefined,
  loading: undefined
}

const reducer = createReducer(
  initialState,
  on(setMetricFinderMetrics, (state, { metrics }): MetricFinderState => ({ ...state, metrics })),
  on(setMetricFinderHolder, (state, { metricHolder }): MetricFinderState => ({ ...state, metricHolder })),
  on(setMetricFinderLoader, (state, { loading }): MetricFinderState => ({ ...state, loading })),
  on(purgeMetricFinderMetrics, (): MetricFinderState => ({ ...initialState }))
)

export const metricFinderReducer = (state: MetricFinderState | undefined, action: Action): MetricFinderState =>
  reducer(state, action)
